import { Edit } from '@carbon/icons-react'
import { Button } from 'app/_components/Button'
import {
  FileActions,
  getIconByType,
} from 'app/_components/Editor/extensions/withUploads/File'
import Link from 'next/link'
import type { RenderElementProps } from 'slate-react'
import { useFocused, useReadOnly, useSelected } from 'slate-react'
import { twMerge } from 'tailwind-merge'

export default function FileBlock({
  attributes,
  children,
  element,
}: RenderElementProps) {
  if (element.type !== 'file-block') throw new Error('Unsupported file type')

  const isEditable = !useReadOnly()
  const isSelected = useSelected()
  const isFocused = useFocused()
  const Icon = getIconByType(element.fileType)

  return (
    <div
      className="relative mt-4 flex w-full overflow-hidden"
      {...attributes}
      contentEditable={false}
    >
      <Link
        tabIndex={-1}
        href={element.url}
        target="_blank"
        className="relative shrink grow overflow-hidden"
      >
        <Button
          className={twMerge(
            'w-full',
            isEditable && isSelected && isFocused && 'ring-text-primary ring-2',
          )}
          title={element.title}
        >
          <span className="line-clamp-1 w-full overflow-hidden text-left">
            {element.title} {children}
          </span>{' '}
          <Icon className="size-4" aria-hidden="true" />
        </Button>
      </Link>
      {isEditable && (
        <FileActions
          element={element}
          trigger={
            <Button
              title="Datei bearbeiten"
              aria-label="Datei bearbeiten"
              shape="icon"
              variant="default"
              type="button"
              className="ml-2 shrink-0"
            >
              <Edit aria-hidden="true" />
            </Button>
          }
        />
      )}
    </div>
  )
}
